module.exports = __webpack_public_path__ + "media/images/logo-w-0e097a2fe96eb7343e6491034e58af88.svg";